<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="类型 0-外部链接" prop="type" >-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="标题" prop="title" >
        <a-input v-model="form.title" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="英文标题" prop="titleEn" >
        <a-input v-model="form.titleEn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="法语标题" prop="titleCn" >
        <a-input v-model="form.titleCn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="西班牙语语标题" prop="titleBm" >
        <a-input v-model="form.titleBm" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="日语语标题" prop="titleIn" >
        <a-input v-model="form.titleIn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" >
<!--        <editor v-model="form.content" />-->
        <a-input v-model="form.content" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="英文内容" prop="contentEn" >
        <a-input v-model="form.contentEn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="法语内容" prop="contentCn" >
        <a-input v-model="form.contentCn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="西班牙语语内容" prop="contentBm" >
        <a-input v-model="form.contentBm" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="日语语内容" prop="contentIn" >
        <a-input v-model="form.contentIn" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="是否启用" prop="isOpen" >-->
<!--        <a-input v-model="form.isOpen" placeholder="请输入是否启用" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="排序" prop="sort" >-->
<!--        <a-input v-model="form.sort" placeholder="请输入排序" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDisposition, addDisposition, updateDisposition } from '@/api/user/disposition'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: 0,

        title: null,

        titleEn: null,

        titleCn: null,

        titleBm: null,

        titleIn: null,

        content: null,

        contentEn: null,

        contentCn: null,

        contentBm: null,

        contentIn: null,

        isOpen: 1,

        sort: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        content: [
          { required: true, message: '阿拉伯内容不能为空', trigger: 'blur' }
        ],
        isOpen: [
          { required: true, message: '是否启用不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: 0,
        title: null,
        titleEn: null,
        titleCn: null,
        titleBm: null,
        titleIn: null,
        content: null,
        contentEn: null,
        contentCn: null,
        contentBm: null,
        contentIn: null,
        isOpen: 1,
        sort: null,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDisposition({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDisposition(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDisposition(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
